export default {
  "presenting_problem": "History of Presenting Problems",
  "attitude": "Attitude to self, Attitude to others [family, friends, relationships]",
  "predominant_mood": "Predominant mood",
  "sensitivity": "Sensitivity",
  "adaptability": "Adaptability",
  "attention_concentration": "Attention/Concentration",
  "motivation": "Motivation",
  "activity": "Activity",
  "aggression": "Aggression",
  "openness": "‘O’penness",
  "conscientiousness": "‘C’onscientiousness",
  "extraversion": "‘E’xtraversion",
  "agreebleness": "‘A’greeableness",
  "neuroticism": "‘N’euroticism",
  "tics_notes":"Notes on Eye contact, Facial Expression, Rapport with Clinician and Mannerisms",
  "psy_notes":"Notes on Psychomotor activity",
  "impul_notes":"Notes on Impulsivity/ Oppositionality/ Aggression",
  "notes": "Notes",
  "impulsivity": "Impulsivity/ Oppositionality/ Aggression",
  "agression": "Aggression",

  "appearance": "Physical Appearance/ Grooming",
  "grooming": "Grooming, Built",
  "eye_contact": "Eye contact",
  "clinician_interaction": "Interactions with Clinician",
  "tics": "Tics, Stereotypes, Mannerisms",
  "notes": "Notes",
  "psychomotor_activity": "Psychomotor Activity",
  "psychomotor_activity_notes": "Notes",
  "volume": "Volume",
  "rate": "Rate",
  "tone": "Tone",
  "relevant": "Relevant",
  "coherent": "Coherent",
  "articulation": "Articulation",
  "emotion": "Emotion",
  "mood_over_a_week": "Mood",
  "affect_right_now": "",
  "mood": "Mood",
  "hallucinations": "Hallucinations",
  "notes": "Notes",
  "comments": "Comments",
  "wishestest": "3 Wishes Test",
  "myhome": "My Home",
  "socialrespectful": "Social - Respectful towards Clinician/Doctors",
  "stream": "Stream",
  "form": "Form",
  "content": "Content",
  "awarenessillness": "Awareness of illness",
  "attributingillness": "Attributing it to mental illness",
  "acceptancetreatment": "Acceptance to treatment",
  "capacitytreatment": "Capacity to choose a form of treatment",
  "awarenessconsequences": "Awareness of the consequences of refusing to take treatment",
  "attentionconcentration": "Attention & Concentration",
  "memory": "Memory",
  "intelligence": "Clinical Estimate of Intelligence",
  "comprehension": "Comprehension",
  "arithmeticskills": "Arithmetic skills - Enquire whether he/she has any difficulty in calculation",
  "abstraction": "Abstraction",
  "judgement": "Judgement",
  "personalobjective": "Personal - What is your future plans? and What is your objective in Life?",
  "personalobjective": "Personal - What is your future plans? and What is your objective in Life?",
  "wellness_ayurveda_diet": "Wellness Goal and Ayurvedic Approach to Diet",
  "breakfast": "Breakfast",
  "lunch": "Lunch",
  "evening": "Evening",
  "dinner": "Dinner",
  "favored": "Favoured",
  "avoided": "Avoided",
  "advice": "Advise",
  "bone_fracture": "Bone fracture",
  "muscle_injuries": "Muscle injuries",
  "ligament_injury": "Ligament injury",
  "tendon_injury": "Tendon injury",
  "physical_deformities": "Physical deformities",
  "duration": "Duration",
  "pranayama": "Pranayama",
  "sitting": "Sitting",
  "standing": "Standing",
  "prone": "Prone",
  "supine": "Supine",
  // yoga plan
  "bone_fracture": "Bone fracture",
  "muscle_injuries": "Muscle injuries",
  "ligament_injury": "Ligament injury",
  "tendon_injury": "Tendon injury",
  "physical_deformities": "Physical deformities",
  "duration": "Duration",
  "duration_period": "Duration Period",
  "pranayama": "Pranayama",
  "sitting": "Sitting",
  "standing": "Standing",
  "prone": "Prone",
  "supine": "Supine",
  "pranayama": "Pranayama",
  "bhedhi_pranayama": "Surya Bhedhi Pranayama",
  "anuloma_viloma": "Surya Anuloma Viloma",
  "chandrabedhi_pranayama": "Chandrabedhi Pranayama",
  "chandra_anuloma_viloma": "Chandra Anuloma Viloma",
  "bhramari_pranayama": "Bhramari Pranayama",
  "ujjayi_pranayama": "Ujjayi Pranayama",
  "sheetali_pranayama": "Sheetali Pranayama",
  "sadanta_sheetali_pranayama": "Sadanta Sheetali Pranayama",
  "sheetakari_pranayama": "Sheetakari Pranayama",
  "bhastrika_pranayama": "Bhastrika Pranayama",
  "kapalabhati_pranayama": "Kapalabhati Pranayama",
  "precautions": "Precautions",
  "recommendations": "Recommendations",
  "number_of_cycles": "Number of cycles",
  "padmasana": "Padmasana",
  "vajrasana": "Vajrasana",
  "shasankasana": "Shasankasana",
  "ushtrasana": "Ushtrasana",
  "paschimottasana": "Paschimottasana",
  "vakrasana": "Vakrasana",
  "ardha": "Ardha",
  "matsyendrasana": "Matsyendrasana",
  "dandasana": "Dandasana",
  "gomukhasana": "Gomukhasana",
  "hamsasana": "Hamsasana",
  "adho_mukha": "Adho Mukha",
  "svanasana": "Svanasana",
  "soopta_vajrasana": "Soopta Vajrasana",
  "mayurasana": "Mayurasana",
  "janu_sheershasana": "Janu Sheershasana",
  "ardha_kati_chakrasana": "Ardha Kati Chakrasana",
  "ardha_chakrasana": "Ardha Chakrasana",
  "trikonasana": "Trikonasana",
  "parshva_konasana": "Parshva Konasana",
  "vrukshasana": "Vrukshasana",
  "ardha_chandrasana": "Ardha Chandrasana",
  "janu_sheershashana": "Janu Sheershashana",
  "parivartita_trikonasana": "Parivartita Trikonasana",
  "padahastasana": "Padahastasana",
  "urdhva_hastasana": "Urdhva Hastasana",
  "veerabhdrasana": "Veerabhdrasana",
  "bhujangasana": "Bhujangasana",
  "dhanurasana": "Dhanurasana",
  "shalabhasana": "Shalabhasana",
  "naukasana": "Naukasana",
  "pavana_muktasana": "Pavana Muktasana",
  "halasana": "Halasana",
  "sethubandhasana": "Sethubandhasana",
  "sarvangasana": "Sarvangasana",
  "shavasana": "Shavasana",
  "sheershsasana": "Sheershsasana",
  "adho_mukha_vrukshasana": "Adho Mukha Vrukshasana",
  "chakrasana": "Chakrasana",
  "soopta_baddha_konasana": "Soopta Baddha Konasana",
  "matsyasana": "Matsyasana",
  "wellness_ayurveda_diet": "Wellness Goal and Ayurvedic Approach to Diet",
  "breakfast": "Breakfast",
  "lunch": "Lunch",
  "evening": "Evening",
  "dinner": "Dinner",
  "favoured": "Favoured",
  "avoided": "Avoided",
  "advice": "Advise",


}



